<script>
    import { CommonHeader } from 'southcn-mobile-ui';
    import moment from 'moment';

    const CONFIG = window._CONFIG;
    const question_data = CONFIG.question_data;
    const favParams = {
        page_key: CONFIG.SID + '-' + CONFIG.QID + '-' + CONFIG.PAGE,
        page_title: question_data.title ? question_data.title : (question_data.article ? question_data.article.title : question_data.form[0].title),
        site_id: CONFIG.SID,
        page_url: window.location.href,
        pub_time: question_data.article ? question_data.article.published_at : question_data.created_at
    };

    var pub_time = favParams.pub_time;
    pub_time && (favParams.pub_time = moment(pub_time).unix());

    export default {
        name: 'CommonHeaderWrap',
        data () {
            return {
                questionData: CONFIG.question_data,
                siteInfo: CONFIG.siteInfo,
                favObj: {isfav: false},
                isAuth: CONFIG.isAuth
            };
        },
        methods: {
            checkIsFav () {
                const {page_key} = favParams;
                this.$api(this.$util.url('api', this.$config.apiUrl.isfav), {
                    page_key
                }, {method: 'GET'}).then(v => {
                    this.favObj = v;
                    const autoFav = this.$storage(true).getItem('auto-fav');
                    if (!v.isfav && autoFav && autoFav.id === question_data.id) {
                        this.setFav();
                    }
                    this.fetchVisitHistory();
                    this.$storage(true).removeItem('auto-fav');
                }).catch(() => {
                    this.isAuth = this.isAuth ? this.isAuth : false;
                });
            },
            setFav () {
                const {isfav} = this.favObj;
                this.$api(this.$util.url('api', isfav ? this.$config.apiUrl.unfav : this.$config.apiUrl.fav), favParams).then(() => {
                    this.favObj.isfav = !this.favObj.isfav;
                });
            },
            fetchVisitHistory () {
                this.$api(this.$util.url('api', this.$config.apiUrl.visitHistory), favParams).then((data) => {
                    console.log(data);
                });
            },
            gotoLogin () {
                this.$storage(true).setItem('auto-fav', {
                    id: question_data.id
                });
                window.open(this.compFavHref);
            },
            handleClick ($e) {
                switch ($e) {
                    case 'search':
                        window.open(`${window._CONFIG.TO_SEARCH_URL}/search/all/${ this.siteInfo.id }`);
                        break;
                    case 'myfav':
                        window.open(this.compMyFavHref);
                        break;
                    case 'fav':
                        this.handleFav();
                        break;
                    case 'unfav':
                        this.setFav();
                        break;
                    case 'login':
                        this.gotoLogin();
                        break;

                }
            },
            handleFav () {
                if (this.isAuth) {
                    this.setFav();
                } else {
                    this.gotoLogin();
                }
            },
            handleOptChange (v) {
                if (v === 'personal') {
                    window.open(window._CONFIG.sxUser.url);
                } else if (v === 'logout') {
                    window.location.href = window._CONFIG.sxLogout + '?qid=' + window._CONFIG.QID + '&sid=' + window._CONFIG.SID;
                }
            }
        },
        computed: {
            titleText () {
                const {article} = this.questionData;
                return article ? '意见征集' : '问卷调查';
            },
            link () {
                return `${ this.siteInfo.proto }://${ this.siteInfo.domain }`;
            },
            isHasIpv6 () {
                return false;
            },
            compFavHref () {
                const {isfav} = this.favObj;
                const {PAGE} = CONFIG;
                const array = window.location.pathname.split('/hdjlpt/');
                const favSxUrl = '/hdjlpt/' + array.pop();
                return isfav ? '' : (PAGE === 'result' ? `${ CONFIG.sxauthURL }-${ window.btoa(favSxUrl) }` : CONFIG.sxauthURL);
            },
            compMyFavHref () {
                return window._CONFIG.favUrl;
            },
            compUserName () {
                if (!this.compNeedLogin) {
                    return '';
                }
                return window._CONFIG.isAuth ? (window._CONFIG.sxUser.displayName + (window._CONFIG.sxUser.parename || '')) : '';
            },
            compNeedLogin () {
                return window._CONFIG.sxUser && window._CONFIG.sxUser.needLogin;
            },
            compActions () {
                if (window._CONFIG.hideCommonHeader === '1') {
                    return [];
                }
                return [ 'search', 'fav', this.compNeedLogin ? 'login' : undefined ];
            }

        },
        components: {CommonHeader},
        mounted () {

            this.checkIsFav();
        }
    };
</script>
<template>
    <common-header name="首页"
                   :actions="compActions"
                   :link="link"
                   :is-fav="favObj.isfav"
                   @btn:click="handleClick"
                   :user-name="compUserName"
                   @opt:change="handleOptChange"
                   :isHasIpv6="isHasIpv6">
        <div class="qa-title">{{ titleText }}</div>
    </common-header>
</template>
<style scoped lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .qa-title {
        width: 100%;
        text-align: center;
        .px2rem(font-size, 40);
        font-weight: bold;
        color: @whiteBg;
    }

    .fav-wrap {
        .px2rem(font-size, 24);
        position: absolute;
        right: 0.156255rem;
        top: 0.3rem;
    }

    .add-fav, .my-fav {
        text-decoration: none;
        cursor: pointer;
        font-family: cmsicon;
        color: #fff;

        &.with-fav {
            color: #ebae5a;
        }
    }

</style>
